const rmLeadsResults = {
  type: 'item',
  label: 'Agent Leads Results B2B',
  code: 'agentLeadsResultsB2B',
  dashboard_uid: 'agentLeadsResultsB2B',
  enable_excel_export: true,
  defaultFilters: {
    account__lead_campaign__transaction_type_code: {
      value: 'B2B',
      label: 'B2B'
    },
    organization_unit: {
      department_type_uid: {
        value: '6800931e-71de-47ae-82a3-82b23e8bd20d',
        label: 'Telesales'
      }
    }
  },
  content: {
    items: [
      {
        type: 'analitics_widget',
        code: 'agentLeadsResults B2B',
        def_version: 5,
        title: 'Agent Leads Results B2B',
        content: {
          data: {
            dataSources: [
              {
                code: 'AccountsListQM',
                name: 'AccountsListQM',
                type: 'QM',
                filter: {},
                fields: ['latest_owner_user_uid', 'sales_result_code'],
                aggregate: [{ id: 'account_uid', type: 'count' }],
                contextMapping: {
                  latest_owner_user_uid: 'user_uid',
                  latest_owner__department_uid: 'department_uid'
                },
                transposeColumns: ['sales_result_code'],
                transposeKey: 'latest_owner_user_uid',
                transposeValueField: 'account_uid',
                qlQuery: `query accountsc($limit: Int, $filter: JSON, $aggregate: [JSON], $groupBy: [String]) { 
                    accountsc(limit: $limit, filter: $filter, aggregate: $aggregate, groupBy: $groupBy) { 
                      edges { edge {  latest_owner_user_uid sales_result_code account_uid latest_owner { uid name type } } } } }`,
                qlVariables: {
                  groupBy: ['latest_owner_user_uid', 'sales_result_code']
                },
                qlEdges: true,
                qlRoot: 'accountsc'
              },
              {
                code: 'AccountsListQM',
                alias: 'AccountsDetailed',
                type: 'QM',
                filter: {},
                aggregate: [{ id: 'account_uid', type: 'count' }],
                contextMapping: {
                  latest_owner_user_uid: 'user_uid',
                  latest_owner: { department_uid: 'department_uid' }
                },
                transposeColumns: ['detailed_status_code'],
                transposeKey: 'latest_owner_user_uid',
                transposeValueField: 'account_uid',
                qlQuery: `query accountsc($limit: Int, $filter: JSON, $aggregate: [JSON], $groupBy: [String]) { 
                accountsc(limit: $limit, filter: $filter, aggregate: $aggregate, groupBy: $groupBy) { 
                  edges { edge {  latest_owner_user_uid detailed_status_code account_uid } } } }`,
                qlVariables: {
                  groupBy: ['detailed_status_code', 'latest_owner_user_uid']
                },
                qlEdges: true,
                qlRoot: 'accountsc'
              },
              {
                code: 'AccountsListQM',
                alias: 'AccountsWon',
                type: 'QM',
                fields: ['won_by_user_uid'],
                aggregate: [{ id: 'account_uid', type: 'count' }],
                contextMapping: {
                  won_by_user_uid: 'user_uid',
                  won_by_user: {
                    department_uid: 'department_uid',
                    organization_unit_uid: 'organization_unit_uid'
                  },
                  customer_since_date: 'activity_date'
                },
                filter: {
                  won_by_user_uid: { $ne: 'null' },
                  filter_won_by_user_uid: true,
                  sales_result_code: 'customer'
                },
                qlQuery: `
                query master($master_uid: String!, $instance_uid: String!, $filter: JSON, $groupBy: [String], $aggregate: [JSON]) {
                  master(master_uid: $master_uid)  { 
                      master_uid
                      name
                      instance(instance_uid: $instance_uid) { 
                          instance_uid
                          name
                          accountsc(filter: $filter, groupBy: $groupBy, aggregate: $aggregate) {
                            edges { 
                              edge 
                              { 
                                account_uid
                                won_by_user_uid
                              }
                            }
                        }
                      }
                  }
                }
                `,
                qlVariables: {
                  aggregate: [{ id: 'account_uid', type: 'count' }],
                  groupBy: ['won_by_user_uid']
                },
                qlEdges: true,
                qlOnly: true,
                qlRoot: 'accountsc'
              },
              {
                code: 'ActivitiesListQM',
                name: 'MeetingsCreated',
                type: 'QM',
                filter: {
                  activity: {
                    activity_type: {
                      medium_code: 'meeting'
                    }
                  },
                  role_code: 'performer'
                },
                contextMapping: {
                  primary_performer_user_uid: 'user',
                  activity: {
                    start_date: 'activity_date'
                  }
                },
                qlQuery: `query activity_participants($limit: Int, $filter: JSON, $aggregate: [JSON], $groupBy: [String]) {
                  activity_participants(limit: $limit, filter: $filter, aggregate: $aggregate, groupBy: $groupBy) {
                      edges { edge { activity_uid user_uid } }
                      pageInfo { count }
                    }
                  }`,
                qlVariables: {
                  aggregate: [{ id: 'activity_uid', type: 'count' }],
                  groupBy: ['user_uid']
                },
                qlEdges: true,
                qlOnly: true,
                qlRoot: 'activity_participants'
              },
              {
                code: 'CrmUser',
                name: 'CrmUser',
                type: 'QM',
                filter: {
                  get_all_instance_uid: true
                },
                qlVariables: {
                  limit: 3000,
                },
                qlQuery: `query master($master_uid: String!, $instance_uid: String!, $filter: JSON, $limit: Int) {
                  master(master_uid: $master_uid)  { 
                      master_uid
                      name
                      instance(instance_uid: $instance_uid) { 
                          instance_uid
                          name
                          users (filter: $filter, limit: $limit) { 
                            user_uid
                            is_active
                            full_name
                            contract_start_date
                            contract_end_date
                            department { 
                              name 
                            }
                          }
                      }
                  }
                }`,
                qlRoot: 'users'
              }
            ],
            combineDataSources: {
              name: 'CombinedDataSource',
              targetKeyField: 'user_uid',
              mapping: [
                {
                  fromDataSourceName: 'AccountsListQM',
                  keyField: 'latest_owner_user_uid',
                  mapping: [
                    {
                      from: 'account_uid',
                      to: 'accounts_all'
                    },
                    {
                      from: 'new',
                      to: 'accounts_new'
                    },
                    {
                      from: 'pending',
                      to: 'accounts_pending'
                    },
                    {
                      from: 'lost',
                      to: 'accounts_lost'
                    },
                    {
                      from: 'quoted',
                      to: 'accounts_quoted'
                    },
                    {
                      from: 'invalid',
                      to: 'accounts_invalid'
                    }
                  ]
                },
                {
                  fromDataSourceName: 'AccountsDetailed',
                  keyField: 'latest_owner_user_uid',
                  mapping: [
                    {
                      from: 'new',
                      to: 'accounts_new',
                      type: 'number'
                    },
                    {
                      from: 'quoted',
                      to: 'accounts_quoted',
                      type: 'number'
                    },
                    {
                      from: 'contacted',
                      to: 'accounts_contacted',
                      type: 'number'
                    },
                    {
                      from: 'touched',
                      to: 'accounts_touched',
                      type: 'number'
                    },
                    {
                      from: 'validated',
                      to: 'accounts_pending',
                      type: 'number'
                    },
                    {
                      from: 'needs_analysis',
                      to: 'accounts_pending',
                      type: 'number'
                    },
                    {
                      from: 'opportunity',
                      to: 'accounts_pending',
                      type: 'number'
                    }
                  ]
                },
                {
                  fromDataSourceName: 'AccountsWon',
                  keyField: 'won_by_user_uid',
                  mapping: [
                    {
                      from: 'account_uid',
                      to: 'accounts_won'
                    }
                  ]
                },
                {
                  fromDataSourceName: 'MeetingsCreated',
                  keyField: 'user_uid',
                  mapping: [
                    {
                      from: 'activity_uid',
                      to: 'meetings_created'
                    }
                  ]
                },
                {
                  fromDataSourceName: 'CrmUser',
                  keyField: 'user_uid',
                  type: 'left',
                  mapping: [
                    {
                      from: 'full_name'
                    },
                    {
                      from: 'contract_start_date'
                    },
                    { from: 'contract_end_date' },
                    { from: 'department__name' },
                    { from: 'is_active' }
                  ]
                }
              ]
            }
          },
          layout: {
            items: [
              {
                type: 'table',
                def_version: 5,
                props: {
                  generate_summary: true,
                  generate_average: true,
                  initialSort: {
                    id: 'contract_start_date',
                    order: 'asc'
                  },
                  columns: [
                    {
                      Header: '#',
                      accessor: 'index',
                      width: 50
                    },
                    {
                      Header: 'RM',
                      accessor: 'full_name',
                      classNameHandler: row => (row.original.is_active ? '' : 'util-opacity50'),
                      detailsPopup: 'user_dashboard',
                      detailsFilterMapping: {
                        user_uid: 'user_uid'
                      }
                    },
                    {
                      Header: 'Start Date',
                      accessor: 'contract_start_date',
                      width: 70
                    },
                    {
                      Header: 'Unanswered',
                      accessor: 'accounts_touched',
                      className: 'util-textRight util-pointer',
                      width: 60,
                      type: 'number',
                      detailsPopup: 'account',
                      detailsFilter: {
                        detailed_status_code: 'touched',
                        latest_owner_user_uid: { '$ne': 'null' }
                      },
                      detailsFilterMapping: {
                        latest_owner_user_uid: 'user_uid'
                      }
                    },
                    {
                      Header: 'Answered',
                      accessor: 'accounts_contacted',
                      className: 'util-textRight util-pointer',
                      width: 60,
                      type: 'number',
                      detailsPopup: 'account',
                      detailsFilter: {
                        detailed_status_code: 'contacted',
                        latest_owner_user_uid: { '$ne': 'null' }
                      },
                      detailsFilterMapping: {
                        latest_owner_user_uid: 'user_uid'
                      }
                    },

                    {
                      Header: 'Quoted',
                      accessor: 'accounts_quoted',
                      className: 'util-textRight util-pointer',
                      width: 60,
                      type: 'number',
                      detailsPopup: 'account',
                      detailsFilter: {
                        detailed_status_code: 'quoted',
                        latest_owner_user_uid: { '$ne': 'null' }
                      },
                      detailsFilterMapping: {
                        latest_owner_user_uid: 'user_uid'
                      }
                    },
                    {
                      Header: 'Bogus',
                      accessor: 'accounts_invalid',
                      className: 'util-textRight util-pointer',
                      width: 60,
                      type: 'number',
                      detailsPopup: 'account',
                      detailsFilter: {
                        sales_result_code: 'invalid',
                        latest_owner_user_uid: { '$ne': 'null' }
                      },
                      detailsFilterMapping: {
                        latest_owner_user_uid: 'user_uid'
                      }
                    },
                    {
                      Header: 'Lost',
                      accessor: 'accounts_lost',
                      className: 'util-textRight util-pointer',
                      width: 60,
                      type: 'number',
                      detailsPopup: 'account',
                      detailsFilter: {
                        sales_result_code: 'lost',
                        latest_owner_user_uid: { '$ne': 'null' }
                      },
                      detailsFilterMapping: {
                        latest_owner_user_uid: 'user_uid'
                      }
                    },
                    {
                      Header: 'Meeting Won',
                      accessor: 'meetings_created',
                      className: 'util-textRight util-pointer',
                      width: 60,
                      type: 'number',
                      detailsPopup: 'activities',
                      contextMapping: {
                        primary_performer_user_uid: 'user',
                        start_date: 'activity_date'
                      },
                      detailsFilter: {
                        is_primary: true,
                        type: { medium_code: 'meeting' },
                        start_date: { $ne: 'null' }
                      },
                      detailsFilterMapping: {
                        performer_user_uid: 'user_uid'
                      }
                    },
                    {
                      Header: 'Won',
                      accessor: 'accounts_won',
                      className: 'util-textRight util-pointer',
                      width: 60,
                      type: 'number',
                      detailsPopup: 'account',
                      detailsFilter: {
                        sales_result_code: 'customer'
                      },
                      detailsFilterMapping: {
                        won_by_user_uid: 'user_uid',
                        account: {
                          owner: { department_uid: 'department_uid' }
                        }
                      },
                      contextMapping: {
                        customer_since_date: 'activity_date'
                      }
                    }
                  ],
                  data: {
                    type: 'dataSource',
                    dataSourceCode: 'CombinedDataSource'
                  }
                }
              }
            ]
          }
        }
      }
    ]
  }
}

export default rmLeadsResults
